/*global angular */
define(
    "diy/undo-redo/historyEntry/Style",
    [
        'diy/undo-redo/historyEntry/Base',
        'diy/util/helper',
        'diy/util/features',
        'jquery'
    ],
    /**
     *
     * @param {module.undoRedo.HistoryEntry.Base} HistoryEntry
     * @param {diy.util.Helper} helper
     * @param {Function} features
     * @param {jQuery} $
     * @returns {*}
     */
    function (HistoryEntry, helper, features, $) {
        'use strict';
        var Style;
        /**
         * @class module.undoRedo.HistoryEntry.Style
         * @template module.undoRedo.HistoryEntry.Style
         * @lends {module.undoRedo.HistoryEntry.Style.prototype}
         * @extends {module.undoRedo.HistoryEntry.Base}
         * @constructor
         */
        Style = HistoryEntry.extend({

            payload: {},

            message: '',
            onExecutedLast: function (executionData) {
                // no interface changes on this action
            },

            /**
             *
             * @returns {Promise|Q.promise}
             */
            openStyleTab: function () {
                var deferred = Q.defer();

                try {
                    if (diy.editor.theming && diy.editor.theming.isStyleWindowLoaded()) {
                        deferred.resolve(true);
                        return deferred.promise;
                    }
                } catch (e) {
                    //
                }
                diy.editor.siteadmin.api.triggerMenuItem('cc-sa-item-style');

                $(document).bind('diy-editor-theming-styleWindowLoaded', function () {
                    deferred.resolve(true);
                });

                return deferred.promise;
            },
            /**
             *
             * @param {Object=} snapshot
             * @returns {Promise|Q.promise}
             */
            createSnapshot: function (snapshot) {
                var
                    deferred = Q.defer();
                if (typeof snapshot === 'undefined') {
                    this.openStyleTab().then(
                        function () {
                            snapshot = diy.editor.theming.getHistorySnapshot();
                            deferred.resolve(snapshot);
                        }
                    );
                } else {
                    this.payload = snapshot;
                    deferred.resolve(snapshot);
                }

                return deferred.promise;
            },
            /**
             *
             * @param {Object=} snapshot
             * @returns {Promise|Q.promise}
             */
            applySnapshot: function applySnapshot(snapshot) {
                var deferred = Q.defer(), toApply;

                if (typeof snapshot === 'undefined') {
                    snapshot = this.payload;
                } else {
                    this.payload = snapshot;
                }

                toApply = angular.copy(snapshot);

                this.openStyleTab()
                    .then(function () {
                        diy.editor.theming.applyHistorySnapshot(toApply, deferred, false);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },
            /**
             *
             * @returns {Promise|Q.promise}
             */
            submit: function submit() {
                var deferred = Q.defer(), toApply;

                toApply = angular.copy(this.payload);
                this.openStyleTab()
                    .then(function () {
                        diy.editor.theming.applyHistorySnapshot(toApply, deferred, true);
                    }.bind(this))
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },
            /**
             *
             * @param {Boolean} lastInBlock
             * @returns {Promise|Q.promise}
             * @deprecated
             */
            execute: function (lastInBlock) {
                var deferred = Q.defer();

                this.openStyleTab()
                    .then(function () {
                        diy.editor.theming.applyHistorySnapshot(this.payload, deferred, lastInBlock);
                    }.bind(this));
                return deferred.promise;
            },

            /**
             *
             * @param {Object} serializedObject
             * @returns {*}
             */
            unserialize: function (serializedObject) {

                this.payload = serializedObject;

                return this._super(serializedObject);
            },

            serialize: function () {
                return this.payload;
            },

            getIdentity: function getIdentity() {
                return 'style';
            }
        });
        return Style;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/historyEntry/Style.js
 ** module id = 904
 ** module chunks = 0
 **/